/* src/app/shared/components/stacked-bar/stacked-bar.component.scss */
.chart-container {
  position: relative;
}
.chart-container h5 {
  position: absolute;
  top: 50%;
  left: 33%;
}
::ng-deep .tick text {
  font-size: 1rem !important;
  fill: #635f5d;
}
::ng-deep .xAxis .tick {
  width: 1rem;
}
::ng-deep .xAxis .tick text {
  word-wrap: break-word;
}
::ng-deep .domain {
  display: none;
}
::ng-deep .axis-label {
  font-size: 1rem !important;
  fill: #8e8883;
}
::ng-deep .title {
  font-size: 1rem !important;
  fill: #635f5d;
}
::ng-deep .tick line {
  stroke: "#eee";
  opacity: 0.1;
}
::ng-deep .chart-tooltip-stacked {
  position: absolute;
  box-sizing: border-box;
  border: 1px solid #eaeaea;
  border-radius: 4px;
  background-color: #ECECEE;
  padding: 12px;
  box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.1);
  margin-top: -30px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 22px;
  z-index: 9999;
  color: #39322b;
  pointer-events: none;
  display: flex;
  text-transform: capitalize;
}
::ng-deep .no-data {
  font-size: 24px !important;
  overflow: hidden !important;
}
::ng-deep .data-container {
  overflow: hidden !important;
}
::ng-deep .rect-text {
  position: relative;
}
::ng-deep .tooltip-draft {
  width: 150px;
  font-size: 1rem;
  margin-left: 0.5rem;
  padding-top: 0.5rem;
}
::ng-deep .tooltip-draft p {
  font-weight: 500;
}
::ng-deep .tooltip-draft h6,
::ng-deep .tooltip-draft .draft-title {
  font-weight: 700;
}
::ng-deep .tooltip-draft .draft-title {
  font-size: 0.8rem;
}
::ng-deep .tooltip-draft h6 {
  margin-bottom: 4rem;
}
::ng-deep .flex-row .tooltip-draft {
  margin-right: 1.5rem !important;
  margin-left: 0;
}
::ng-deep .top20Chart .yAxis .tick text {
  opacity: 0;
}
::ng-deep .top20Chart .yAxis .tick:first-of-type text,
::ng-deep .top20Chart .yAxis .tick:last-of-type text {
  opacity: 1;
}
/*# sourceMappingURL=stacked-bar.component.css.map */
